Object.defineProperty(exports, "__esModule", { value: true });
function requestHasBody(action) {
    return action !== 'Get' && action !== 'Check';
}
exports.default = requestHasBody;
//# sourceMappingURL=requestHasBody.js.map